import { render, staticRenderFns } from "./TabPagamentosMensais.vue?vue&type=template&id=422a4f5e"
import script from "./TabPagamentosMensais.vue?vue&type=script&lang=js"
export * from "./TabPagamentosMensais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports